module.exports = {"id":"191059","name":"Javi Márquez","rating":"73","photo":"./data/images/photos/2/191059.png","club":{"name":"Gimnàstic","logo":"./data/images/clubs/Gimnastic.png"},"positions":["MC","MOC","MDC"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JaviMarquez0.json
// module id = 1939
// module chunks = 0